import Vue from 'vue';
import moment from 'moment';

export default ({ groupBy = ['product'], dateRange, statuses, includeCancelled, sort } = {}) => (
  new Promise((resolve, reject) => {
    const params = new URLSearchParams();

    (groupBy || ['product']).forEach(g => params.append('group_by[]', g));

    if (statuses && statuses.length) {
      statuses.forEach(s => params.append('statuses[]', s));
    }

    if (includeCancelled) {
      params.append('include_cancelled', '1');
    }

    if (sort) {
      params.append('sort', sort);
    }

    if (dateRange && dateRange[0] && dateRange[1]) {
      params.append('start', moment(dateRange[0]).format('YYYY-MM-DD'));
      params.append('end', moment(dateRange[1]).format('YYYY-MM-DD'));
    }

    Vue.$http.get(`/reports/aggregated_sales?${params.toString()}`)
      .then(({ data }) => {
        resolve({
          columns: data.data.columns,
          rows: data.data.rows,
          summary: data.data.summary,
          meta: data.data.meta,
        });
      })
      .catch(reject);
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/aggregatedSales.js